import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem("mona_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Terjadi kesalahan";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d.msg || d);
}

export const rp = (x) => (x < 0 ? "-" : "") + "Rp " + Math.round(Math.abs(x || 0)).toLocaleString("id-ID");
export const num = (x, d = 3) => Number(x ?? 0).toLocaleString("id-ID", { maximumFractionDigits: d });
export const dt = (s) => (s ? new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-");
export const today = () => new Date(Date.now() + 7 * 3600e3).toISOString().slice(0, 10);
export const photoUrl = (id) => `${API}/attachments/${id}?t=${localStorage.getItem("mona_token")}`;

export const STATUS = {
  waiting_receiving: ["Menunggu Penerimaan", "bg-amber-100 text-amber-800 border-amber-300"],
  waiting_verification: ["Menunggu Verifikasi", "bg-sky-100 text-sky-800 border-sky-300"],
  verified: ["Diterima · masuk stok", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  cancelled: ["Dibatalkan", "bg-rose-100 text-rose-800 border-rose-300"],
  refunded: ["Direfund", "bg-purple-100 text-purple-800 border-purple-300"],
  preparing: ["Disiapkan", "bg-slate-100 text-slate-700 border-slate-300"],
  completed: ["Diterima · masuk stok", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  draft: ["Draf", "bg-slate-100 text-slate-600 border-slate-300"],
  submitted: ["Diajukan", "bg-sky-100 text-sky-800 border-sky-300"],
  reversed: ["Dibalik", "bg-rose-100 text-rose-800 border-rose-300"],
  posted: ["Terposting", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  open: ["Terbuka", "bg-amber-100 text-amber-800 border-amber-300"],
  approved: ["Disetujui", "bg-indigo-100 text-indigo-800 border-indigo-300"],
  fulfilled: ["Dipenuhi", "bg-teal-100 text-teal-800 border-teal-300"],
  rejected: ["Ditolak", "bg-rose-100 text-rose-800 border-rose-300"],
  converted: ["Jadi Pembelian", "bg-teal-100 text-teal-800 border-teal-300"],
  paid: ["Lunas", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  unpaid: ["Belum dibayar", "bg-rose-100 text-rose-800 border-rose-300"],
  partial: ["Dibayar sebagian", "bg-amber-100 text-amber-800 border-amber-300"],
  void: ["Batal", "bg-slate-100 text-slate-600 border-slate-300"],
  done: ["Selesai", "bg-teal-100 text-teal-800 border-teal-300"],
  scheduled: ["Terjadwal", "bg-indigo-100 text-indigo-800 border-indigo-300"],
};

export const MOVE = {
  purchase_in: "Pembelian masuk", purchase_reversal: "Reversal pembelian", transfer_in: "Transfer masuk", transfer_out: "Transfer keluar",
  production_in: "Hasil produksi", production_out: "Bahan produksi", production_reversal: "Reversal produksi", sales_consumption: "Konsumsi penjualan",
  sales_reversal: "Reversal penjualan", opname_adjustment: "Selisih opname", adjustment: "Penyesuaian", waste: "Waste", opening_balance: "Saldo awal", consignment_in: "Konsinyasi masuk", consignment_out: "Ditarik supplier (konsinyasi)",
};

export const ITEM_TYPES = { raw_material: "Bahan baku", packaging: "Kemasan", finished: "Produk jadi", semi_finished: "Setengah jadi", consumable: "Consumable", other: "Lainnya" };
export const CASH_KIND = { purchase: "Pembayaran pembelian", refund: "Refund", expense: "Biaya", money_in: "Uang masuk", money_out: "Uang keluar", transfer_in: "Transfer masuk", transfer_out: "Transfer keluar",
  cash_sales: "Penjualan tunai", deposit_out: "Setoran ke bank", deposit_in: "Setoran dari outlet", owner_topup: "Top-up Owner", debt_payment: "Bayar hutang supplier", maintenance: "Biaya perawatan" };
export const unitsOf = (it) => (it ? [it.base_unit, ...(it.conversions || []).map((c) => c.unit)] : []);
export const factorOf = (it, u) => (!it ? 1 : u === it.base_unit ? 1 : Number((it.conversions || []).find((c) => c.unit === u)?.factor || 1));
